let conversionRateMap = {
  SINGAPORE: {
    currency: "SG$",
    rate: 1.35,
  },
  "UNITED ARAB EMIRATES": {
    currency: "AED",
    rate: 3.8,
  },
  "UNITED KINGDOM": {
    currency: "£",
    rate: 0.79,
  },
  "NEW ZEALAND": {
    currency: "NZ$",
    rate: 1.81,
  },
  CANADA: {
    currency: "CA$",
    rate: 1.45,
  },
  AUSTRALIA: {
    currency: "AU$",
    rate: 1.63,
  },
  CYPRUS: {
    currency: "€",
    rate: 0.87,
  },
  ESTONIA: {
    currency: "€",
    rate: 0.87,
  },
  FINLAND: {
    currency: "€",
    rate: 0.87,
  },
  FRANCE: {
    currency: "€",
    rate: 0.87,
  },
  GERMANY: {
    currency: "€",
    rate: 0.87,
  },
  IRELAND: {
    currency: "€",
    rate: 0.87,
  },
  ITALY: {
    currency: "€",
    rate: 0.87,
  },
  LATVIA: {
    currency: "€",
    rate: 0.87,
  },
  LITHUANIA: {
    currency: "€",
    rate: 0.87,
  },
  LUXEMBOURG: {
    currency: "€",
    rate: 0.87,
  },
  MALTA: {
    currency: "€",
    rate: 0.87,
  },
  NETHERLANDS: {
    currency: "€",
    rate: 0.87,
  },
  PORTUGAL: {
    currency: "€",
    rate: 0.87,
  },
  "SAN MARINO": {
    currency: "€",
    rate: 0.87,
  },
  SLOVAKIA: {
    currency: "€",
    rate: 0.87,
  },
  SLOVENIA: {
    currency: "€",
    rate: 0.87,
  },
  SPAIN: {
    currency: "€",
    rate: 0.87,
  },
  "VATICAN CITY": {
    currency: "€",
    rate: 0.87,
  },
  REST: {
    currency: "$",
    rate: 1,
  },
};

function extractAmount(str) {
  const cleaned = str.replace(/[^\d.,-]/g, '').trim();
  const normalized = cleaned.replace(/,/g, '');
  return normalized;
}

function convertAmount(originalAmount, conversionRate) {
  return Math.ceil(originalAmount * conversionRate).toFixed(0);
}

document.addEventListener("DOMContentLoaded", function () {
  let convertiblePrices = document.getElementsByClassName(
    "currency_convertible"
  );
  if (convertiblePrices) {
    fetch("https://robify.ezapp.ovh/country?justcountry=1")
      .then((response) => response.text())
      .then((country) => {
        try {
          const converted = conversionRateMap[country] || conversionRateMap["REST"];
          for (let i = 0; i < convertiblePrices.length; i++) {
            const amountToConvert = extractAmount(convertiblePrices[i].innerHTML);
            convertiblePrices[i].innerHTML =
              converted.currency + convertAmount(amountToConvert, converted.rate);
          }
        } catch (e) {
          console.error("Unable to manual convert currency:", e);
        }
      });
  }
});